<script type="text/javascript">
	// Material.io tooltips not yet supported on Web, so I built one quickly.
	// https://material.io/components/tooltips/
	import { onMount } from "svelte";
	import InputHelper from "../Helpers/InputHelper";

	// primary, secondary, surface, background. see mdc themes.
	export let variant = "primary";

	// the text/innerHTML for the tooltip
	export let text = "";

	// the spacing between the element and the tooltip.
	export let spacing = 16;

	// the placement relative to the slot
	export let position = "bottom"; // left | right | top | bottom;

	export let inline = false;

	export let cls = "";


	let element;
	let tooltip;
	let onOver = (e) => {
		if (InputHelper.isTouchScreen()) {
			return;
		}

		// tooltip.
		const pos = getOffset(element);

		// place the tooltip directly in the center of the associated element.
		tooltip.style.left = pos.left + (pos.width * 0.5) + "px";
		tooltip.style.top = pos.top + (pos.height * 0.5) + "px";

		// place it directly underneath
		if (position === "bottom") {
			tooltip.style.top = pos.top + (pos.height * 1.0) + spacing + "px";
		}
		else if (position === "top") {
			tooltip.style.top = (pos.top - spacing) + "px";
		}
		else if (position === "right") {
			tooltip.style.left = pos.left + (pos.width * 1.0) + spacing + "px";
		}
		else if (position === "left") {
			tooltip.style.left = (pos.left - spacing) + "px";
		}

		tooltip.classList.add("hover");
	}
	let onOut = (e) => {
		if (InputHelper.isTouchScreen()) {
			return;
		}

		tooltip.classList.remove("hover");
	}

	let getOffset = (element) => {
		var rect = element.getBoundingClientRect();
		var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
		var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		return {
			top: rect.top + scrollTop,
			left: rect.left + scrollLeft,
			width: rect.width,
			height: rect.height
		}
	}

	onMount(()=>{
		if (InputHelper.isTouchScreen()) {
			return;
		}
		let e = document.getElementById("tooltip-overlay");
		if (e == null) {
			e = document.createElement("div");
			e.id = "tooltip-overlay";
			e.style.position = "absolute";
			e.style.left = 0 + "px";
			e.style.top = 0 + "px";
			e.style.zIndex = 1001;
			document.body.firstElementChild.appendChild(e);
		}

		e.appendChild(tooltip);
	});

</script>

<style type="text/scss">
	.tooltip-container {}
	.tooltip-container.inline {
		display:inline-block;
	}
	.tooltip {
		background-color: #333;
		padding: 6px;
		font-size:12px;
		position: fixed;
		display: block;
		transform: translate(-50%, -50%);
		border-radius: 3px;
		z-index:100;

		transition-timing-function:ease-in;
		transition:0.15s;
		opacity:0;
	}
	.tooltip.primary {
		background-color: var(--mdc-theme-primary);
		color: var(--mdc-theme-on-primary);
	}
	.tooltip.secondary {
		background-color: var(--mdc-theme-secondary);
		color: var(--mdc-theme-on-secondary);
	}
	.tooltip.background {
		background-color: var(--mdc-theme-background);
		color: var(--mdc-theme-on-background);
	}
	.tooltip.surface {
		background-color: var(--mdc-theme-surface);
		color: var(--mdc-theme-on-surface);
	}
	.tooltip.hover {
		opacity:1;
	}
</style>

<div class={"tooltip-container " + cls + " " + ((inline)?"inline":"")}  bind:this={element} on:mouseover={onOver} on:mouseout={onOut} >
	<slot/>
</div>
<div bind:this={tooltip} class={"tooltip " + variant}>{@html text}</div>
